import { Component, Input, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TestBed } from '@angular/core/testing';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../../global/services/global.service';
import { EFileService } from '../../efile.service';
import { ApiResponse } from '../../models/api-response.model';
import { Submission } from '../../models/submission.model';
import { SubmissionService } from '../submission.service';
import * as _ from 'lodash-es';

@Component({
    selector: 'efile-submit',
    templateUrl: './submit.component.html',
    styleUrls: ['./submit.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SubmitComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  private static readonly JCD_KEY_FEDERAL = 250;

  //Properties
  TEST = 'TEST';
  PRODUCTION = 'PRODUCTION';
  btnPingText:string = 'Ping IRS';
  btnSubmit: string = 'Submit';
  btnAck: string = 'Get Acknowledgement';
  envType:string = this.TEST;
  pinging: boolean = false;
  submitting: boolean = false;
  submission: Submission;
  acking: boolean = false;


  constructor(
    private efileService: EFileService,
    private gtwSnackbarService: GtwSnackbarService,
    private submissionSerivce: SubmissionService,
    private gtwGlobal: GlobalService,
  ) {
      this.submission = this.submissionSerivce.activeSubmission;
    }
    
    ngOnInit(): void {
  }

  envSelected(envType:string) : void{
    this.envType = envType;
  }

  pingIRS(): void{
    if(this.pinging) return;

    this.btnPingText = '';
    this.pinging = true;
    this.efileService.pingIrsServer(0,this.envType).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((response:ApiResponse) =>{
      this.pinging = false;
      this.btnPingText = 'Ping IRS';
      if(response.callSuccess === "1"){
          this.gtwSnackbarService.openSnackBar("Successfully Pinged IRS Server!","gtw-snackbar--green");
        }else{
          this.gtwSnackbarService.openSnackBar("Failed to Ping to IRS!","gtw-snackbar--red");

        }
    })
  }
  submit(): void{
    if(this.submitting) return;

    this.btnSubmit = '';
    this.submitting = true;
    this.efileService.submitToIRS(0,this.envType,this.submission.SUBMISSION_ID.toString()).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((response:ApiResponse) =>{
      this.submitting = false;
      this.btnSubmit = 'Submit';
      if(response.callSuccess === "1"){
          this.gtwSnackbarService.openSnackBar("Successfully Submitted to IRS!","gtw-snackbar--green");
        }else{
          this.gtwSnackbarService.openSnackBar("Failed to Submit to IRS!","gtw-snackbar--red");

        }
    })
  }
  pollAck(): void{
    if(this.acking) return;

    this.btnAck = '';
    this.acking = true;
    const taxYear = String(this.submission.TAX_YEAR);
    const jcdKey = SubmitComponent.JCD_KEY_FEDERAL;
    const scenario = String(this.resolveDefaultScenario(taxYear) ?? '');
    this.efileService.pollAck(
      0,
      this.submission.SUBMISSION_ID.toString(),
      taxYear,
      scenario,
      jcdKey,
    ).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((response:ApiResponse) =>{
      this.acking = false;
      this.btnAck = 'Get Acknowledgement';
      if(response.callSuccess === "1"){
          this.gtwSnackbarService.openSnackBar("Successfully fetched Acknowledgement!","gtw-snackbar--green");
        }else{
          this.gtwSnackbarService.openSnackBar("Failed to fetch Acknowledgement!","gtw-snackbar--red");

        }
    })
  }

  private resolveDefaultScenario(taxYear: string): string | number | undefined {
    const values: any[] = (this.gtwGlobal.global as any)?.inputs?.tax_year?.values || [];
    const ty = String(taxYear ?? '');
    const found = _.find(values, { label: ty }) || _.find(values, (v: any) => String(v?.value) === ty);
    const scenarios: any[] = found?.scenarios || [];
    const def = _.find(
      scenarios,
      (s: any) =>
        Number(s?.jcd_key) === SubmitComponent.JCD_KEY_FEDERAL && s?.default_scenario === 'Y',
    );
    return def?.scenario ?? (this.gtwGlobal.global as any)?.globalParams?.scenario;
  }

}
